import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import "../static/quickAppointment.css";

const QuickAppointmentForm = ({ initialDate = "", initialHour = "" }) => {
  const today = new Date().toISOString().split("T")[0];

const hourOptions = useMemo(() => {
  const options = [];

  for (let hour = 8; hour <= 20; hour += 1) {
    for (const minute of ["00", "30"]) {
      if (hour === 20 && minute === "30") continue;

      const value = `${String(hour).padStart(2, "0")}:${minute}`;

      options.push({
        value,
        label: value,
      });
    }
  }

  return options;
}, []);

  const normaliseHour = (value) => {
    if (!value) return "";
    const hour = String(value).split(":")[0];
    return `${String(hour).padStart(0, "30")}:00`;
  };

  const [form, setForm] = useState({
    pet_name: "",
    catdog: "Dog",
    owner_name: "",
    owner_phone: "",
    appointment_date: initialDate || today,
    appointment_hour: normaliseHour(initialHour),
    note: "",
  });

  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState("");

  useEffect(() => {
    setForm((previous) => ({
      ...previous,
      appointment_date: initialDate || previous.appointment_date || today,
      appointment_hour:
        normaliseHour(initialHour) || previous.appointment_hour,
    }));
  }, [initialDate, initialHour, today]);

  const updateField = (event) => {
    const { name, value } = event.target;

    setForm((previous) => ({
      ...previous,
      [name]: value,
    }));
  };

  const submitQuickAppointment = async (event) => {
    event.preventDefault();

    setSaving(true);
    setMessage("");

    try {
      const response = await axios.post("/petgrooming/quick-appointments/", form);

      setMessage(`Appointment saved for ${response.data.pet_name}.`);

      setForm({
        pet_name: "",
        catdog: "Dog",
        owner_phone: "",
        appointment_date: initialDate || today,
        appointment_hour: normaliseHour(initialHour),
        note: " ",
      });
    } catch (error) {
      console.error("Quick appointment error:", error.response?.data || error);

      const backendError = error.response?.data?.error;

      setMessage(
        backendError
          ? JSON.stringify(backendError)
          : "Could not save appointment. Check the server response."
      );
    } finally {
      setSaving(false);
    }
  };

  return (
    <section className="quick-appointment-card">
      <div className="quick-appointment-head">
        <span>Quick booking</span>
        <h2>Add pet appointment</h2>
        <p>Save the basic booking now and complete the full profile later.</p>
      </div>

      <form className="quick-appointment-form" onSubmit={submitQuickAppointment}>
        <label>
          Pet name
          <input
            name="pet_name"
            value={form.pet_name}
            onChange={updateField}
            placeholder="Pet name"
            required
          />
        </label>

        <label>
          Pet type
          <select name="catdog" value={form.catdog} onChange={updateField}>
            <option value="Dog">Dog</option>
            <option value="Cat">Cat</option>
          </select>
        </label>
        <label>
          Owner name
          <input
            name="owner_name"
            value={form.owner_name}
            onChange={updateField}
            placeholder="Owner full name"
            required
          />
        </label>
        <label>
          Owner phone
          <input
            name="owner_phone"
            value={form.owner_phone}
            onChange={updateField}
            placeholder="07..."
            required
          />
        </label>

        <label>
          Date
          <input
            type="date"
            name="appointment_date"
            value={form.appointment_date}
            onChange={updateField}
            required
          />
        </label>

        <label>
          Hour
          <select
            name="appointment_hour"
            value={form.appointment_hour}
            onChange={updateField}
            required
          >
            <option value="">Select hour</option>

            {hourOptions.map((item) => (
              <option key={item.value} value={item.value}>
                {item.label}
              </option>
            ))}
          </select>
        </label>

        <label className="quick-full">
          Note
          <textarea
            name="note"
            value={form.note}
            onChange={updateField}
            rows="3"
          />
        </label>

        {message && <div className="quick-message">{message}</div>}

        <button type="submit" disabled={saving}>
          {saving ? "Saving..." : "Save appointment"}
        </button>
      </form>
    </section>
  );
};

export default QuickAppointmentForm;